import type * as React from 'react';
import { get } from '@Domain/Api';
import userStatusesFetched, {
	type UserStatusesFetchedAction,
	type UserStatusesFetchedPayload,
} from '@Application/Users/UserStatuses/Actions/userStatusesFetched';
import userStatusesFetchFailed, {
	type UserStatusesFetchFailedAction,
} from '@Application/Users/UserStatuses/Actions/userStatusesFetchFailed';
import type FetchUserStatuses from '@Application/Users/UserStatuses/Queries/FetchUserStatuses';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserStatusesFetchedAction | UserStatusesFetchFailedAction;

export default (_query: FetchUserStatuses) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<UserStatusesFetchedPayload>(
				`${parameters.api.host}/api/enums/user-statuses`,
			);

			const action = userStatusesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userStatusesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
